import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-type", "data-width", "data-height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-type": _ctx.type,
        "data-width": _ctx.width,
        "data-height": _ctx.height
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1));
}
